import { useEffect } from 'react';
import checkCircle from '../../../icons/check-circle-correct.svg';
import errorIcon from '../../../icons/error.svg';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as BinIcon } from '../../../icons/icon_delete_bin.svg';

const UploaderFile = ({ name, uid, removeFile, status, dataReset, resetUploaded, isNewUi }) => {
  useEffect(() => {
    if (dataReset) {
      removeFile(null, uid);
      resetUploaded(false);
    }
  }, [dataReset]);

  return (
    <div className='uploaded-file-wrapper'>
      {!isNewUi && (
        <div className='uploaded-file'>
          {status === 'loading' && <span className='loading'></span>}
          {status === 'success' && <img src={checkCircle} alt='' />}
          {status === 'error' && <img src={errorIcon} alt='' />}
          {name}
        </div>
      )}
      {!isNewUi && status === 'success' && (
        <button type='button' className='button button--small' onClick={(e) => removeFile(e, uid, null, false, true)}>
          <BinIcon />
          <FormattedMessage id='Remove file' />
        </button>
      )}
    </div>
  );
};
export default UploaderFile;
